import React from "react";
import styled, { css } from "styled-components";
import { pompadour } from "../colors";

const AsapAppBar = (props) => {
  const {
    leftContent,
    rightContent,
    content,
    leftContentStyle,
    rightContentStyle,
    contentStyle,
  } = props;
  return (
    <AsapAppBarView {...props}>
      {leftContent && <LeftContent style={leftContentStyle}>{leftContent}</LeftContent>}
      {content && <Content style={contentStyle}>{content}</Content>}
      {rightContent && <RightContent style={rightContentStyle}>{rightContent}</RightContent>}
    </AsapAppBarView>
  );
};
export default AsapAppBar;

const AsapAppBarView = styled.div`
  background-color: ${pompadour};
  height: 64px;
  display: flex;
  align-items: center;

  color: white;
  font-family: Roboto, sans-serif;
  font-size: 20px;
  font-weight: 500;

  ${({ fixed }) =>
    fixed &&
    css`
      z-index: 99;
      position: fixed;
      top: 0;
      width: 100%;
    `};
`;

const LeftContent = styled.div`
  padding-left: 20px;
`;

const Content = styled.div`
  flex: 1;
  padding-left: 20px;
`;

const RightContent = styled.div`
  padding-right: 20px;
`;



// WEBPACK FOOTER //
// ./src/components/AsapAppBar.js